import { Grid, Typography } from "@mui/material";
import {ControlledDatePicker} from "src/components/forms";
import CardActions from "../../../components/CardActions";
import { UseFormReturn } from "react-hook-form";
import {FormOperacionCLFB, OperacionCLFB} from "../types/types";
import { dateFormatter } from "src/utils/formatters";
import {OperacionCLFBFields} from "../types/fields";

const SchemaFields = OperacionCLFBFields

type DatosOperacionProps = {
    formMethods: UseFormReturn<FormOperacionCLFB>
    readOnly?: boolean
    operacion?: OperacionCLFB
    nuevo?: boolean
}

const SeccionCLFBDatosOperacion = ({ formMethods, readOnly, operacion, nuevo }: DatosOperacionProps) => {

    const { control, watch } = formMethods

    return (
        <CardActions title='Datos Operación' colapsable>
            <Grid container spacing={4}>
                {
                    !nuevo &&
                    <Grid item xs={12} md={3}>
                        <Typography variant='body2'>Usuario Alta</Typography>
                        <Typography>{operacion && `${operacion.nombreUsuarioAlta} ${operacion.apellidoUsuarioAlta}`}</Typography>
                    </Grid>
                }
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Aprobación</Typography>
                                <Typography>{operacion && dateFormatter.toShortDate(operacion?.fechaAprobacion)}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={SchemaFields.FechaAprobacion}
                                label='Fecha Aprobación'
                                control={control}
                                selectedSections={undefined}
                                fullWidth
                                readOnly={readOnly}
                            />
                    }
                </Grid>
                <Grid item xs={12} md={3}>
                    {
                        readOnly ?
                            <>
                                <Typography variant='body2'>Fecha Vencimiento</Typography>
                                <Typography>{operacion ? dateFormatter.toShortDate(operacion?.fechaVencimiento) : '-'}</Typography>
                            </> :
                            <ControlledDatePicker
                                name={SchemaFields.FechaVencimiento}
                                label='Fecha Vencimiento'
                                control={control}
                                selectedSections={undefined}
                                minDate={watch(OperacionCLFBFields.FechaAprobacion)}
                                fullWidth
                                readOnly={readOnly}
                            />
                    }
                </Grid>
            </Grid>
        </CardActions>
    )
}

export default SeccionCLFBDatosOperacion
